import angular from "angular";

angular
    .module('app')
    .component('newCourseLessons', {
        template: require('./new-course-lessons.html'),
        controller: ['$http', '$uibModal', 'Notifier', '$timeout', '$rootScope', controller],
        bindings: {
            course: '<',
            chapters: '<',
            activeLesson: '<',
        }
    });

function controller($http, $uibModal, Notifier, $timeout, $rootScope) {

    let $ctrl = this;

    $rootScope.$on('LessonUpdated', (event, data) => {
        let lessonId = data.lesson_id;
        let title = data.title;

        $ctrl.chapters.forEach(function (chapter) {
            chapter.lessons.forEach(function (lesson) {
                if (lessonId == lesson.id) {
                    lesson.title = title;
                }
            });
        });
    });

    $ctrl.$onInit = function () {
        if ($ctrl.activeLesson) {
            $ctrl.title = $ctrl.activeLesson.title;
            $timeout(function () {
                $ctrl.chapters.forEach(function (chapter) {
                    chapter.lessons.forEach(function (lesson) {
                        if ($ctrl.activeLesson.id == lesson.id) {
                            chapter.open = true;
                        }
                    });
                });
            });
        } else {
            $timeout(function () {
                $ctrl.chapters[0].open = true;
            });
        }
        $ctrl.courseId = $ctrl.course.id;
    };

    $ctrl.openChapterForm = function (chapter) {
        $uibModal
            .open({
                component: 'chapterForm',
                resolve: {
                    course: function () {
                        return $ctrl.course;
                    },
                    chapter: function () {
                        return chapter;
                    }
                },
                keyboard: false,
                backdrop: true
            })
            .result
            .then(
                function (result) {
                    if (chapter) {
                        chapter.title = result.title;
                        chapter.description = result.description;
                    } else {
                        result.lectures = [];
                        $ctrl.chapters.push(result);
                    }
                },
                function () {
                }
            );
    };

    $ctrl.openLessonForm = function (chapter) {
        $uibModal
            .open({
                component: 'lessonCreateForm',
                resolve: {
                    course: function () {
                        return $ctrl.course;
                    },
                    chapter: function () {
                        return chapter;
                    }
                }
            })
            .result
            .then(
                function (result) {
                    if (!chapter.lessons) {
                        chapter.lessons = [];
                    }
                    chapter.lessons.push(result);
                    window.location = `/admin/courses/${$ctrl.course.id}/lessons/${result.id}`;
                },
                function () {
                }
            );
    };

    $ctrl.deleteChapter = function (chapter, index) {

        if (chapter.deleteLoading) {
            return;
        }

        if (!confirm('Confirm?')) {
            return;
        }

        chapter.deleteLoading = true;

        $http
            .delete(
                `/admin/courses/${$ctrl.course.id}/chapters/${chapter.id}`
            )
            .then(
                function (response) {
                    $ctrl.chapters.splice(index, 1);
                    // alert('Success deleted');
                    Notifier.success('Успешно удалено', 2);
                },
                function (error) {
                    chapter.deleteLoading = false;
                    // alert(error.data.message);
                    Notifier.error(error.data.message, 2);
                }
            );
    };

    $ctrl.toggleChapter = function (chapter) {
        chapter.open = !chapter.open;
    };

    $ctrl.openLessonsSchedulerForm = function () {
        $uibModal
            .open({
                component: 'lessonSchedulerForm',
                size : 'lg',
                resolve: {
                    course: function () {
                        return $ctrl.course;
                    }
                }
            })
            .result
            .then(
                function (result) {
                },
                function () {
                }
            );
    }

}
